module.exports = __webpack_public_path__ + "static/dragon_gold_action_mtg_clb-1cf587e66e0f831245296e100438213b.png";